module.exports = __webpack_public_path__ + "img/variables.7a2ea006.jpg";